import { render } from "./poll_form.vue?vue&type=template&id=a33a297e"
import script from "./poll_form.js?vue&type=script&lang=js"
export * from "./poll_form.js?vue&type=script&lang=js"

import "./poll_form.vue?vue&type=style&index=0&id=a33a297e&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__